import { Link } from 'react-router-dom';

export default function ArticlePreview() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 md:gap-14 items-center">
          <div className="w-full lg:w-1/2">
            <div className="relative w-full h-[340px] md:h-[420px] rounded-3xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Organized%20workspace%20with%20macbook%20showing%20fashion%20product%20comparison%20table%2C%20surrounded%20by%20clothing%20samples%20and%20coffee%2C%20warm%20afternoon%20light%20through%20sheer%20curtains%2C%20editorial%20productivity%20lifestyle%20photography%2C%20aesthetic%20creative%20professional%20workspace&width=800&height=600&seq=article-preview-v2&orientation=landscape"
                alt="Pandabuy Spreadsheet shopping guide"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
          </div>

          <div className="w-full lg:w-1/2 flex flex-col">
            <span className="inline-block px-3 py-1 bg-accent-100 text-accent-800 text-xs font-medium rounded-full mb-4 w-fit">
              Buying Guide
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-[1.15] mb-5">
              How to Use a Pandabuy <span className="italic">Spreadsheet</span> Like a Pro
            </h2>
            <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-4">
              Pandabuy spreadsheets have become the go-to tool for savvy shoppers looking to discover the best finds
              from global suppliers. Whether you&apos;re hunting for the latest sneaker releases, trending streetwear
              pieces, or hidden gem accessories, a well-organized pandabuy sheet can save you hours of scrolling
              through endless product listings.
            </p>
            <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-8">
              In this comprehensive guide, we break down everything you need to know about navigating pandabuy
              spreadsheets — from understanding product codes and quality tiers to spotting the most reliable
              sellers and maximizing your shipping strategy for the best deals.
            </p>
            <Link
              to="/pandabuy-spreadsheet-guide"
              className="group inline-flex items-center gap-2 px-6 py-3 bg-background-50 border border-background-300/60 rounded-full text-sm font-semibold text-foreground-900 hover:border-primary-300 hover:bg-primary-50 transition-all cursor-pointer whitespace-nowrap w-fit"
            >
              Read Full Guide
              <i className="ri-arrow-right-up-line text-base group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}